export const VERIFY_QUOTE_CARD_CLASS =
  "w-full h-full min-h-[480px] rounded-lg border border-[#D9D9D9] bg-white shadow-sm flex flex-col";
